const WhatIsIncluded=[
    {
        id:1,
        img:"./assests/images/professional-editors.png",
        title:"Professional Editors",
        desc:`The team of experienced and professional editors are waiting
                  to provide editing services for you. Our experts possess
                  abilities and skills to execute finest editing services.`
    },
    {
        id:2,
        img:"./assests/images/economical-service.png",
        title:"Economical Service",
        desc:"Categorising problems with grammar, structure, formatting or referencing of your papers."
    },
    {
        id:3,
        img:"./assests/images/timely-delivery.png",
        title:"Timely Delivery",
        desc:`Our organisation possess extra-ordinary careful behavior in
        meeting deadlines and delivering services on-time. By getting
        our service you do not need to be worried about delivery
        issues which usually exist in other organisations.`
    },
    {
        id:4,
        img:"./assests/images/subject-experts.png",
        title:"Subject Experts",
        desc:`Our organisation hired every subject-matter expert for editing
        services because we believe in quality service and customer
        satisfaction.`
    },

]

export default WhatIsIncluded